module.exports = __webpack_public_path__ + "img/credit-one-club-inspiration-1.11fbec97.jpg";